import React, {createContext, useState, useContext, useEffect} from 'react';
import {jwtDecode} from "jwt-decode";
import { toast } from "../../utils/toast";

// const AuthContext = createContext(null);
//
// export const AuthProvider = ({ children }) => {
//     const [isPasswordResetAllowed, setIsPasswordResetAllowed] = useState(false);
//
//     const allowPasswordReset = () => setIsPasswordResetAllowed(true);
//     const disallowPasswordReset = () => setIsPasswordResetAllowed(false);
//
//
//
//     return (
//         <AuthContext.Provider value={{ isPasswordResetAllowed, allowPasswordReset, disallowPasswordReset }}>
//             {children}
//         </AuthContext.Provider>
//     );
// };
//
// export const useAuth = () => useContext(AuthContext);

// 로그인 인증 과정 상태 관리
// AuthContext 생성
const AuthContext = createContext();

// AuthProvider: 앱 전체에서 인증 상태 관리
export function AuthProvider({ children }) {
    const [auth, setAuth] = useState({
        isLoggedIn: false,
        role: null,
    });

    // 초기화: 앱이 로드될 때 localStorage에서 인증 상태 복구
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            setAuth({ isLoggedIn: false, role: null });
            return;
        }
        const fetchAuthStatus = async () => {

            try {
                const response = await fetch("/api/auth/check", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Unauthorized");
                }

                const data = await response.json();

                if (!data.data) {
                    throw new Error("유저 정보가 없습니다.");
                }

                const role = localStorage.getItem("role");
                setAuth({ isLoggedIn: true, role: role });
                console.log("인증 상태 확인 성공:", data.data);
            } catch (error) {
                console.error("인증 상태 확인 실패:", error);

                toast("로그인 세션이 만료되었습니다. 다시 로그인 해주세요.");
                logout();  // 인증 실패 시 로그아웃
            }
        };

        fetchAuthStatus();
    }, []);

    // 로그인 함수: 로그인 상태와 역할을 설정하고 localStorage에 저장
    const login = (token, role) => {
        setAuth({ isLoggedIn: true, role });
        localStorage.setItem("token", token); // 토큰 저장
        localStorage.setItem("role", role);  // 역할 저장
    };

    // 로그아웃 함수: 상태 초기화 및 localStorage에서 제거
    const logout = async() => {
        try {
            await fetch("/api/logout", { method: "POST", credentials: "include" }); // ✅ 서버에서도 로그아웃 처리
        } catch (error) {
            console.error("백엔드 로그아웃 실패:", error);
        }

        setAuth({ isLoggedIn: false, role: null });
        localStorage.removeItem("token"); // 토큰 제거
        localStorage.removeItem("role");  // 역할 제거

        window.location.href = "/"; // 로그아웃 후 홈페이지로 이동
    };

    return (
        <AuthContext.Provider value={{ auth, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

// AuthContext를 사용하는 커스텀 훅
export function useAuth() {
    return useContext(AuthContext);
}